// Shared form content for creating/editing organizations
import React from 'react';
import { View, ScrollView, ActivityIndicator, Text, StyleSheet } from 'react-native';
import { ADMIN_COLORS } from '@/constants/admin';
import { IEntrataUser } from '@/types/admin/organizations';
import { OrganizationInfoSection, PaymentAccountsSection } from './form-sections';
import { EntrataUsersInput } from './desktop';

interface OrganizationFormContentProps {
  formData: {
    name: string;
    domain: string;
    paymentAccounts: any[];
    entrataUsers: IEntrataUser[];
  };
  errors: {
    name: string;
    domain: string;
  };
  isLoadingConfigs?: boolean;
  isDisabled?: boolean;
  onNameChange: (text: string) => void;
  onDomainChange: (text: string) => void;
  onEntrataUsersChange: (users: IEntrataUser[]) => void;
  onPaymentAccountChange: (index: number, accountNumber: string) => void;
}

export const OrganizationFormContent: React.FC<OrganizationFormContentProps> = ({
  formData,
  errors,
  isLoadingConfigs = false,
  isDisabled = false,
  onNameChange,
  onDomainChange,
  onEntrataUsersChange,
  onPaymentAccountChange,
}) => {
  return (
    <ScrollView style={styles.scrollView} showsVerticalScrollIndicator={false}>
      {/* Organization Information */}
      <OrganizationInfoSection
        name={formData.name}
        domain={formData.domain}
        nameError={errors.name}
        domainError={errors.domain}
        onNameChange={onNameChange}
        onDomainChange={onDomainChange}
        disabled={isDisabled}
      />

      {/* Entrata Users */}
      <View style={styles.section}>
        {isLoadingConfigs ? (
          <View style={styles.loadingContainer}>
            <ActivityIndicator size="small" color={ADMIN_COLORS.BUTTON.ADD_BUTTON_BACKGROUND} />
            <Text style={styles.loadingText}>Loading Entrata users...</Text>
          </View>
        ) : (
          <EntrataUsersInput
            users={formData.entrataUsers}
            onChange={onEntrataUsersChange}
            disabled={isDisabled}
          />
        )}
      </View>

      {/* Payment Accounts */}
      <PaymentAccountsSection
        paymentAccounts={formData.paymentAccounts}
        onPaymentAccountChange={onPaymentAccountChange}
        disabled={isDisabled}
      />
    </ScrollView>
  );
};

const styles = StyleSheet.create({
  scrollView: {
    flex: 1,
    paddingHorizontal: 20,
  },
  section: {
    paddingVertical: 20,
    borderBottomWidth: 1,
    borderBottomColor: ADMIN_COLORS.BORDER,
  },
  loadingContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    padding: 16,
    gap: 12,
  },
  loadingText: {
    fontSize: 14,
    color: ADMIN_COLORS.TEXT.SECONDARY,
  },
});

